module.exports = __webpack_public_path__ + "static/img/4.d0d292f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/4.png
// module id = NIY7
// module chunks = 0